import React from "react";
import { Alert } from "antd";

const ErrorAlert = ({ error }) => {
  if (!error) return null;
  const message =
    typeof error === "string" ? error : error?.message || JSON.stringify(error);

  return (
    <Alert
      type="error"
      message={message}
      showIcon
      data-testid="error-alert"
      style={{ marginBottom: 16 }}
    />
  );
};

export default ErrorAlert;
